module.exports = __webpack_public_path__ + "img/slide-services-1.cf4983de.webp";